import {colors, drawFigure} from '../utils';

// background big (like your mother) quote name
export class Title extends PIXI.Container{
  constructor(App){
    super();
    this.zIndex = 0;
    this.App = App;
    this.text = new PIXI.Text(App.quotes.currentSymbol, {fontSize: '155px', fontFamily: 'Dintext, Arial, Helvetica, sans-serif', fill: colors.backgroundTitle});
    this.text.alpha = 0.02;
    this.text.position.set((App.renderer.width/App.devicePixelRatio - this.text.width) / 2, (App.renderer.height/App.devicePixelRatio - this.text.height) / 2);
    this.addChild(this.text);
  }

  setNewTitle(title){
    let App = this.App;
    this.text.text = title;
    this.text.position.set((App.renderer.width/App.devicePixelRatio - this.text.width) / 2, (App.renderer.height/App.devicePixelRatio - this.text.height) / 2);
  }

  render(){}
}

export class HoverMaskTrade extends PIXI.Container{
  constructor(App){
    super();
    this.zIndex = 3;
    this.App = App;

    this.hoverMaskGreen = new PIXI.Graphics();
    this.hoverMaskGreen.isMask = true;

    this.hoverMaskRed = new PIXI.Graphics();
    this.hoverMaskRed.isMask = true;

    this.textureTradeUp = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/green.png');
    this.textureTradeUp.mask = this.hoverMaskGreen;

    this.textureTradeDown = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/red.png');
    this.textureTradeDown.mask = this.hoverMaskRed;


    this.arrowTradeUp = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/arrow_up.png');
    this.arrowTradeDown = new PIXI.Sprite.fromImage('/static/img/webtrader/chart/arrow_down.png');

    this.arrowTradeUp.width = this.arrowTradeDown.width = 17;
    this.arrowTradeUp.height = this.arrowTradeDown.height =  18;

    // this.arrowTradeUp.alpha = 0.0;
    // this.textureTradeDown.alpha = 0.0;

    this.addChild(
        this.hoverMaskGreen,
        this.textureTradeUp,
        this.arrowTradeUp,
        this.hoverMaskRed,
        this.textureTradeDown,
        this.arrowTradeDown
    );

  }

  render(){

    if (this.App.points.length === 0) {
      return;
    }

    if (!this.App.isHoverTrade()) {
      this.hoverMaskGreen.clear();
      this.hoverMaskRed.clear();

      this.arrowTradeUp.visible = false;
      this.textureTradeUp.visible = false;
      this.arrowTradeDown.visible = false;
      this.textureTradeDown.visible = false;

      return;
    }
    let y = this.App.getY(_.last(this.App.points).value) + this.App.chartPosition.top;

    if (this.App.trades.hoverTypeTrade === 0) {
      this.hoverMaskRed.clear();
      this.arrowTradeDown.visible = false;
      this.textureTradeDown.visible = false;
      this.hoverMaskGreen
          .clear()
          .lineStyle(1, this.App.getColorTrade(), 1)
          .moveTo(0, y)
          .lineTo(0, 0)
          .lineTo(this.App.renderer.width/this.App.devicePixelRatio,0)
          .lineTo(this.App.renderer.width/this.App.devicePixelRatio,y)
          .endFill();

      this.textureTradeUp.scale.x = this.App.renderer.width/this.App.devicePixelRatio;
      this.textureTradeUp.height = y;
      this.textureTradeUp.y = 0;

      this.arrowTradeUp.visible = true;
      this.textureTradeUp.visible = true;
      this.arrowTradeUp.x = _.last(this.App.displayedPoints).x + 10;
      this.arrowTradeUp.y = y - this.arrowTradeUp.height - 10;
    }

    if (this.App.trades.hoverTypeTrade === 1) {
      this.hoverMaskGreen.clear();
      this.arrowTradeUp.visible = false;
      this.textureTradeUp.visible = false;
      this.hoverMaskRed
          .clear()
          .lineStyle(1, this.App.getColorTrade(), 1)
          .moveTo(0, y)
          .lineTo(0, this.App.renderer.height)
          .lineTo(this.App.renderer.width/this.App.devicePixelRatio, this.App.renderer.height)
          .lineTo(this.App.renderer.width/this.App.devicePixelRatio,y)
          .endFill();

      this.textureTradeDown.scale.x = this.App.renderer.width/this.App.devicePixelRatio;
      this.textureTradeDown.height = this.App.renderer.height - y;
      this.textureTradeDown.y = y;

      this.arrowTradeDown.visible = true;
      this.textureTradeDown.visible = true;
      this.arrowTradeDown.x = _.last(this.App.displayedPoints).x + 10;
      this.arrowTradeDown.y = y + 10;
    }

  }
}